// extracted by mini-css-extract-plugin
module.exports = {"base":"GoogleAuthButton_base__3A3MB","icon":"GoogleAuthButton_icon__3yq8b"};